import React from 'react';
import { faHouse } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function HouseSolidIcon(props) {
  return <FontAwesomeIcon icon={faHouse} {...props} />;
}
